import React, { useState } from "react";
import { Button, Typography } from "@mui/material";

import analytics from "fond/analytics";
import { HUBSPOT_FORM_PROVIDE_FEEDBACK } from "fond/constants";
import { HubSpotModal } from "fond/hubspot/HubSpotModal";
import { useAppSelector } from "fond/utils/hooks";

import { Chip, Tooltip } from "./BetaNotification.styles";

const BetaNotification: React.FC = () => {
  const [showFeedbackForm, setShowFeedbackForm] = useState(false);
  const currentUsername = useAppSelector((state) => state.cognito.user?.username);

  const handleOnShareFeedback = () => {
    analytics.track("topbar.beta-flag.share-feedback.clicked");
    setShowFeedbackForm(true);
  };

  return (
    <>
      <Tooltip
        title={
          <>
            <Typography variant="subtitle2">Beta Program</Typography>
            Market Lens will be released soon. Try this feature in beta and share your feedback!
            <Button fullWidth onClick={handleOnShareFeedback} sx={{ mt: 2 }} variant="contained" color="primary">
              Share Feedback
            </Button>
          </>
        }
      >
        <Chip label="BETA" variant="filled" size="medium" color="secondary" />
      </Tooltip>
      {showFeedbackForm && (
        <HubSpotModal
          header="Market Lens Beta Feedback"
          formId={HUBSPOT_FORM_PROVIDE_FEEDBACK}
          initialData={{
            "0-1/email": currentUsername,
          }}
          onClose={() => setShowFeedbackForm(false)}
        />
      )}
    </>
  );
};

export default BetaNotification;
